export default function footer() {
  const footerLinks = {
    quick: [
      { label: "الرئيسية", href: "/" },
      { label: "من نحن", href: "/about" },
      { label: "خدماتنا", href: "/services" },
      { label: "تواصل معنا", href: "/contact" },
    ],

    services: [
      { label: "إعادة التدوير", href: "/services" },
      { label: "جمع المواد", href: "/services" },
      { label: "فرز وتجهيز المواد", href: "/services" },
    ],
  };

  return (
    <>
      <footer className="bg-gray-950 text-white">
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-green-600 font-bold">
                  خ
                </div>

                <div>
                  <h2 className="font-bold">خبراء التدوير</h2>
                  <p className="text-xs text-gray-400">Recycling Experts</p>
                </div>
              </div>

              <p className="mt-5 max-w-sm text-sm leading-7 text-gray-400">
                نقدم حلولًا احترافية في جمع وفرز وإعادة تدوير المواد، ونساهم في
                بناء مستقبل أكثر استدامة.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-bold">روابط سريعة</h3>

              <ul className="mt-5 space-y-3">
                {footerLinks.quick.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 transition hover:text-green-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="font-bold">خدماتنا</h3>

              <ul className="mt-5 space-y-3">
                {footerLinks.services.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 transition hover:text-green-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-bold">تواصل معنا</h3>

              <div className="mt-5 space-y-4 text-sm text-gray-400">
                <p>المملكة العربية السعودية</p>
                <p>info@example.com</p>
                <p>+966 50 000 0000</p>
              </div>

              {/* Social */}
              <div className="mt-6">
                <p className="mb-3 text-sm font-semibold text-white">تابعنا</p>

                <div className="flex gap-2">
                  {["Instagram", "X", "TikTok", "LinkedIn"].map((social) => (
                    <a
                      key={social}
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social}
                      className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-xs text-gray-400 transition hover:bg-green-600 hover:text-white"
                    >
                      {social === "Instagram"
                        ? "IG"
                        : social === "LinkedIn"
                          ? "in"
                          : social}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-gray-500 md:flex-row md:items-center md:justify-between">
            <p>
              © {new Date().getFullYear()} خبراء التدوير. جميع الحقوق محفوظة.
            </p>

            <div className="flex gap-5">
              <a href="/privacy" className="transition hover:text-white">
                سياسة الخصوصية
              </a>

              <a href="/terms" className="transition hover:text-white">
                الشروط والأحكام
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
